import type { KeywordsItem } from '../types';

/**
 * 实施例特征关键词服务
 * 用于获取和管理特征相关的关键词
 */
export const EmbodimentFeatureKeywordsService = Symbol.for('EmbodimentFeatureKeywordsService');

export interface EmbodimentFeatureKeywordsService {
    /**
     * 获取关键词列表
     * @param num - 权利要求编号
     * @param concept - 特征概念
     * @returns 关键词列表
     */
    fetchKeywords(num: string, concept: string): Promise<KeywordsItem[]>;
}
